import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { em } from '../../../../../utils/styles'

import { HOW_RETURN_VALUES } from '../../constants'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { showFieldError, renderValidation } from '../../../../../utils/validations'
import { getExceptionMessage } from '../../../../../utils/exceptions'
import SolicitudeFields from './SolicitudeFields'
import Button from '../../../../../components/Button'
import InfoBox from '../../../../../components/InfoBox'
import Fieldset from '../../../../../components/FormFields/Fieldset'
import { AddButton } from '../../../../../components/FormFields/FieldList'
import { ReactComponent as PlusIcon } from '../../../../../components/Icons/icon-plus.svg'
import FormRow from '../../../../../components/FormFields/FormRow'
import SelectField from '../../../../../components/FormFields/SelectField'
import FormActions from '../../../../../components/FormFields/FormAction/FormActions'
import FormError from '../../../../../components/FormFields/FormError'
import valueMessages from './valueMessages'
import { SectionSubTitle } from '../../../../../components/Section';
import { FieldArray } from 'formik'
import { ReactComponent as AddIcon } from '../../../../../components/Icons/add-document-icon.svg'
import { StatusSteps } from '../../StatusSteps'
import CheckboxField from '../../../../../components/FormFields/CheckboxField'
import Label from '../../../../../components/FormFields/Label'

const IsClientWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-top: 2em;
  padding-left: 1.5em;
`

// TODO: move to components
const RemoveIcon = styled(PlusIcon)`
  transform: rotate(45deg);
  margin-left: ${em(5)};
  margin-bottom: ${em(-3)};
`

function SolicitudeForm({
  values,
  status = {},
  errors,
  touched,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleBlur,
  handleSubmit
}) {
  return (
    <form onSubmit={handleSubmit}>
      <FormRow>
        <IsClientWrapper>
          <Label>¿Eres cliente de Triodos Bank?</Label>
          <CheckboxField
            type='checkbox'
            name='is_client'
            value={true}
            checked={values.is_client === true}
            onChange={() => setFieldValue('is_client', true)}
            error={showFieldError('is_client', { errors, touched })}
            label={'Sí'}
          />
          <CheckboxField
            type='checkbox'
            name='is_client'
            value={'hi'}
            checked={values.is_client === false}
            onChange={() => setFieldValue('is_client', false)}
            error={showFieldError('is_client', { errors, touched })}
            label={'No'}
          />
        </IsClientWrapper>
      </FormRow>
      <SolicitudeFields
        values={values}
        isClient={values.is_client}
        errors={errors}
        touched={touched}
        setFieldValue={setFieldValue}
        handleChange={handleChange}
        handleBlur={handleBlur}
      />
      <FormRow>
        <SelectField
          name='how_plan_return_it'
          value={values.how_plan_return_it}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('how_plan_return_it', { errors, touched })}
          help={renderValidation('how_plan_return_it', { errors, touched })}
          label='¿Cómo piensas devolverlo?'
          tip='En función del análisis del proyecto/iniciativa y de la tipología de producto la entidad podrá requerir las garantías adecuadas a la financiación solicitada una vez iniciemos el estudio de la misma.'
          forceTip
          full
        >
          <option value='' />
          {Object.values(HOW_RETURN_VALUES).map(value => (
            <FormattedMessage key={value} {...valueMessages[`howReturn${value}`]}>
              {message => <option value={value}>{message}</option>}
            </FormattedMessage>
          ))}
        </SelectField>
      </FormRow>
      <FormRow>
        <Fieldset as={InfoBox}>
          <SectionSubTitle as='legend'>
            ¿Necesitas financiación adicional?
          </SectionSubTitle>
          <p>Si necesitas algún otro tipo de financiación añádela pulsando sobre el siguiente botón y la tendremos en cuenta en el proceso de tu solicitud.</p>
          <FieldArray
            name='extra'
            render={helpers => (
              <Fragment>
                {values.extra.map((value, index) => {
                  return (
                  <Fragment key={index}>
                    <SolicitudeFields
                      values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      namePrefix={`extra[${index}].`}
                    />
                    <AddButton
                      title='Eliminar'
                      onClick={() => helpers.remove(index)}
                    >
                      Eliminar financiación adicional
                      <RemoveIcon />
                    </AddButton>
                  </Fragment>
                )})}
                <AddButton
                  onClick={() => helpers.push({
                    how_much: '',
                    finnancial_type: '',
                    how_much_time_months: ''
                  })}
                >
                  Añadir otro producto <AddIcon />
                </AddButton>
              </Fragment>
            )}
          />
        </Fieldset>
      </FormRow>
      {status.error && (
        <FormError>
          <FormattedMessage {...getExceptionMessage(status.error)} />
        </FormError>
      )}
      <FormActions>
        <Button type='submit' disabled={isSubmitting}>Continuar</Button>
      </FormActions>
      <StatusSteps />
    </form>
  )
}

SolicitudeForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  status: PropTypes.shape({
    error: PropTypes.instanceOf(Error),
    success: PropTypes.object
  }),
  isSubmitting: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default SolicitudeForm
